import { createAxiosInstance } from "@/common/axiosInstance";
var BASE_PATH = 'search_v1';
var searchFetcher = function searchFetcher() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var axiosInstance1 = createAxiosInstance(req, BASE_PATH, true);
  return axiosInstance1;
};
export default searchFetcher;